export const trustStats = [
  { number: '25+', label: 'Years Experience', icon: 'ri-time-fill' },
  { number: '500+', label: 'Vehicles Protected', icon: 'ri-car-fill' },
  { number: 'XPEL', label: 'Certified Installer', icon: 'ri-award-fill' },
  { number: '5★', label: 'Rated in South Windsor', icon: 'ri-star-fill' },
  { number: 'Lifetime', label: 'Warranty Available', icon: 'ri-shield-star-fill' },
];

export const services = [
  {
    id: 'ppf',
    icon: 'ri-shield-fill',
    title: 'Paint Protection Film (PPF)',
    description: 'XPEL-certified PPF installation creates an invisible armor over your paint. Self-healing technology protects against rock chips, road debris, and scratches — permanently.',
    bullets: ['XPEL ULTIMATE PLUS', 'Self-Healing Technology', 'Crystal-Clear Gloss Finish', '10-Year Warranty'],
    link: '/services/paint-protection-film',
    dark: true,
  },
  {
    id: 'ceramic',
    icon: 'ri-sparkling-2-fill',
    title: 'Ceramic Coating',
    description: 'Professional-grade ceramic coating delivers an ultra-slick hydrophobic barrier that repels water, contaminants, and UV damage while amplifying your paint depth and gloss.',
    bullets: ['9H Surface Hardness', 'Hydrophobic Protection', 'UV & Oxidation Resistance', '5-Year Durability'],
    link: '/services/ceramic-coating',
    dark: false,
  },
  {
    id: 'tint',
    icon: 'ri-sun-fill',
    title: 'Window Tint',
    description: 'Premium window film blocks heat and UV rays, enhances privacy, and gives your vehicle a sleek, dark finish. All films are CT-legal and carry a lifetime warranty.',
    bullets: ['99% UV Rejection', 'Heat Rejection', 'Privacy & Aesthetics', 'Lifetime Warranty'],
    link: '/services/window-tint',
    dark: false,
  },
  {
    id: 'matte-ppf',
    icon: 'ri-paint-fill',
    title: 'Matte PPF / Color Change',
    description: 'Transform any gloss paint into a stunning satin or matte finish while protecting your paint underneath. Perfect for a stealth look with full paint protection built in.',
    bullets: ['Satin & Matte Finishes', 'Full Color Change', 'Paint Protection Included', 'Reversible'],
    link: '/services/matte-ppf',
    dark: false,
  },
  {
    id: 'windshield',
    icon: 'ri-eye-fill',
    title: 'Windshield Protection Film',
    description: 'XPEL windshield film shields your glass from chips, cracks, and sand abrasion — dramatically reducing the risk of a costly windshield replacement.',
    bullets: ['Impact Resistance', 'Optical Clarity', 'Anti-Glare Option', 'Simple Replacement'],
    link: '/services/windshield-protection',
    dark: false,
  },
  {
    id: 'motorcycle',
    icon: 'ri-motorbike-fill',
    title: 'Motorcycle PPF & Ceramic',
    description: 'Custom-cut protection packages for motorcycles and exotics. Preserve your bike\'s finish from stone chips and road debris with precision PPF and ceramic coating.',
    bullets: ['Custom-Cut Films', 'Fairing Protection', 'Ceramic Topcoat', 'All Makes & Models'],
    link: '/services',
    dark: false,
  },
];

export const whyChooseUs = [
  {
    icon: 'ri-award-fill',
    title: 'XPEL Certified Installer',
    desc: 'We are certified by XPEL — the world leader in paint protection film. Only trained and tested shops earn this designation.',
  },
  {
    icon: 'ri-focus-3-fill',
    title: 'Precision Application',
    desc: 'Every film is computer-cut and hand-installed by detail-obsessed technicians. Zero bubbles, no lift edges, no shortcuts.',
  },
  {
    icon: 'ri-vip-diamond-fill',
    title: 'Premium Brands Only',
    desc: 'We install only the world\'s best protection products — XPEL, SunTek, and Ceramic Pro. No budget films, no compromises.',
  },
  {
    icon: 'ri-history-fill',
    title: '25+ Years of Passion',
    desc: 'Over two decades of automotive expertise in Hartford County. We live and breathe cars — and it shows in every single install.',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Marcus T.',
    location: 'South Windsor, CT',
    rating: 5,
    text: 'Had XPEL PPF installed on my new BMW M3 Competition. The result is absolutely flawless — couldn\'t even tell it was applied. These guys are true professionals. Worth every dollar for the peace of mind alone. Best shop in Connecticut.',
    image: 'https://public.readdy.ai/ai/img_res/bef75bb12394a50e9340bde8427cc1d1.jpg',
  },
  {
    id: 2,
    name: 'Jennifer L.',
    location: 'Hartford, CT',
    rating: 5,
    text: 'Full ceramic coating on my Tesla Model S. The hydrophobic effect is incredible — water just sheets right off. Three months later the car still looks like it just left the showroom. DBN Garage is the only shop I trust.',
    image: 'https://readdy.ai/api/search-image?query=smiling%20professional%20woman%20car%20owner%20portrait%20clean%20warm%20background%20headshot%20natural%20lighting&width=80&height=80&seq=rev_auto2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Ryan C.',
    location: 'Glastonbury, CT',
    rating: 5,
    text: 'Window tint and full-front PPF on my Porsche 911. The attention to detail is unmatched. They treated my car like their own. Professional, communicative, and the finished product exceeded all expectations.',
    image: 'https://readdy.ai/api/search-image?query=young%20man%20car%20enthusiast%20smiling%20portrait%20natural%20lighting%20clean%20background%20headshot%20warm%20tone&width=80&height=80&seq=rev_auto3&orientation=squarish',
  },
  {
    id: 4,
    name: 'Daniel M.',
    location: 'West Hartford, CT',
    rating: 5,
    text: 'Brought my Ferrari 488 in for matte PPF. I was nervous trusting any shop with it — but DBN Garage\'s precision blew me away. The satin finish looks absolutely stunning. Only shop for exotics in CT.',
    image: 'https://readdy.ai/api/search-image?query=professional%20man%20exotic%20car%20owner%20smiling%20clean%20background%20natural%20lighting%20portrait%20headshot%20warm&width=80&height=80&seq=rev_auto4&orientation=squarish',
  },
  {
    id: 5,
    name: 'Samantha K.',
    location: 'Manchester, CT',
    rating: 5,
    text: 'Full paint correction and ceramic coating on my Audi RS7. The paint looks better than new. DBN Garage\'s knowledge, communication, and workmanship are second to none in the Hartford area.',
    image: 'https://readdy.ai/api/search-image?query=professional%20woman%20smiling%20car%20enthusiast%20portrait%20warm%20natural%20lighting%20clean%20background%20headshot&width=80&height=80&seq=rev_auto5&orientation=squarish',
  },
];

export const serviceAreas = [
  'South Windsor', 'Hartford', 'Manchester', 'Glastonbury', 'West Hartford',
  'Enfield', 'Windsor', 'East Hartford', 'Wethersfield', 'Bloomfield',
  'Simsbury', 'Farmington', 'Newington', 'Rocky Hill', 'Vernon',
  'Tolland', 'Avon', 'Canton', 'Suffield', 'Windsor Locks',
];

export const processSteps = [
  {
    number: '01',
    icon: 'ri-message-3-line',
    title: 'Free Consultation',
    desc: 'Contact us to discuss your vehicle and goals. We recommend the ideal protection package and provide a transparent, no-obligation quote.',
  },
  {
    number: '02',
    icon: 'ri-tools-line',
    title: 'Prep & Decontamination',
    desc: 'We perform a full paint correction, clay bar decontamination, and thorough panel prep to ensure perfect adhesion and a flawless result.',
  },
  {
    number: '03',
    icon: 'ri-focus-3-line',
    title: 'Precision Installation',
    desc: 'Using computer-cut patterns and professional tools, our certified installers apply your film or coating with exacting, millimeter-level precision.',
  },
  {
    number: '04',
    icon: 'ri-checkbox-circle-line',
    title: 'Inspection & Delivery',
    desc: 'Every vehicle passes a rigorous quality inspection before delivery. You receive full care instructions and complete warranty documentation.',
  },
];

export const faqs = [
  {
    q: 'Where can I get PPF installed in South Windsor, CT?',
    a: 'DBN Garage is South Windsor\'s premier XPEL-certified paint protection film installer. Located in South Windsor, CT, we serve the entire Hartford County area including Manchester, Glastonbury, West Hartford, and surrounding towns. Call us to schedule your free consultation today.',
  },
  {
    q: 'How much does ceramic coating cost?',
    a: 'Ceramic coating at DBN Garage ranges from $600 to $2,000+ depending on vehicle size, paint condition, and the coating package selected. We offer entry-level protection up to our multi-year professional-grade systems. All packages include paint decontamination and a full vehicle inspection.',
  },
  {
    q: 'Is PPF worth it for a new car?',
    a: 'Absolutely. Paint protection film is the single best investment for a new vehicle. It shields paint from rock chips, road debris, and scratches before they happen. PPF also significantly preserves resale value. Most new car owners say they wish they had installed it from day one.',
  },
  {
    q: 'What is the difference between PPF and ceramic coating?',
    a: 'PPF is a physical film that absorbs impacts, rock chips, and scratches — it\'s your vehicle\'s armor. Ceramic coating is a liquid polymer that bonds to paint, providing hydrophobic protection, UV resistance, and enhanced gloss. Many customers install both for maximum protection and appearance.',
  },
  {
    q: 'How long does window tint installation take?',
    a: 'Window tinting typically takes 2–4 hours depending on vehicle size and windows being tinted. The film requires 3–5 days to fully cure, during which we recommend keeping windows rolled up. We use premium films with lifetime warranties on all our tint installations.',
  },
  {
    q: 'What is the best way to protect a vehicle\'s paint?',
    a: 'The most comprehensive approach combines PPF on high-impact areas with ceramic coating over the entire vehicle. PPF handles physical protection against chips and scratches, while ceramic coating repels environmental contaminants, UV damage, and water. Together they provide complete, full-spectrum paint protection.',
  },
  {
    q: 'Do you perform paint correction before PPF or ceramic coating?',
    a: 'Yes — every installation includes a full vehicle inspection. If swirl marks, scratches, or paint defects are present, we recommend paint correction before any film or coating is applied. Installing protection over flawed paint locks in those imperfections permanently, so we never skip this step.',
  },
  {
    q: 'What warranty do you offer on your work?',
    a: 'XPEL PPF comes with a 10-year manufacturer warranty against yellowing, cracking, or delamination. Ceramic coatings carry 2–5 year warranties depending on the product. Our labor is fully guaranteed — if something isn\'t right, we come back and make it right, period.',
  },
];

export const galleryImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=luxury%20BMW%20M3%20full%20paint%20protection%20film%20installed%20gleaming%20perfect%20reflections%20dark%20automotive%20studio%20photography%20premium%20car%20protection%20glossy%20flawless%20finish%20professional&width=700&height=500&seq=gal_auto1&orientation=landscape',
    alt: 'BMW M3 full PPF paint protection film South Windsor CT',
    label: 'BMW M3 — Full PPF',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=professional%20ceramic%20coating%20application%20luxury%20black%20Porsche%20911%20studio%20automotive%20photography%20perfect%20mirror%20reflections%20glass%20finish%20premium%20detailing%20dark%20background&width=500&height=350&seq=gal_auto2&orientation=landscape',
    alt: 'Porsche 911 ceramic coating Hartford CT professional installation',
    label: 'Porsche 911 — Ceramic Coating',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=sleek%20Tesla%20Model%203%20dark%20premium%20window%20tint%20installation%20automotive%20professional%20shop%20clean%20modern%20deep%20tint%20luxury%20electric%20vehicle%20side%20view&width=450&height=350&seq=gal_auto3&orientation=landscape',
    alt: 'Tesla Model 3 premium window tint South Windsor Connecticut',
    label: 'Tesla Model 3 — Window Tint',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Ferrari%20matte%20satin%20paint%20protection%20film%20wrap%20exotic%20car%20dark%20studio%20stunning%20satin%20finish%20premium%20automotive%20photography%20luxury%20protection&width=400&height=350&seq=gal_auto4&orientation=squarish',
    alt: 'Ferrari matte PPF color change film wrap premium',
    label: 'Ferrari — Matte PPF Wrap',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Lamborghini%20Urus%20full%20vehicle%20paint%20protection%20film%20clear%20bra%20installation%20exotic%20SUV%20premium%20auto%20protection%20studio%20photography%20dark%20background%20glossy%20perfect&width=700&height=400&seq=gal_auto5&orientation=landscape',
    alt: 'Lamborghini Urus full PPF wrap South Windsor CT',
    label: 'Lamborghini Urus — Full PPF',
  },
];
